import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Lock, Pencil } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

export default function BudgetAdminNoteCard({ budgetId, note, onSaved }) {
  const [editing, setEditing] = useState(false);
  const [text, setText] = useState(note || "");
  const [saving, setSaving] = useState(false);
  useEffect(() => { setText(note || ""); }, [note]);

  const save = async () => {
    setSaving(true);
    try {
      await api.patch(`/budgets/${budgetId}/admin-note`, { admin_note: text });
      toast.success("Observação interna salva");
      setEditing(false);
      onSaved?.(text.trim());
    } catch {
      toast.error("Erro ao salvar");
    } finally { setSaving(false); }
  };

  return (
    <section className="rounded-xl border border-amber-200 bg-amber-50/70 p-3" data-testid="budget-admin-note-card">
      <div className="flex items-center justify-between gap-2">
        <p className="text-[11px] font-black uppercase tracking-wider text-amber-700 flex items-center gap-1">
          <Lock className="w-3 h-3" /> Observação interna — só você vê
        </p>
        {!editing && (
          <button type="button" onClick={() => setEditing(true)} className="text-[11px] font-semibold text-amber-800 hover:underline inline-flex items-center gap-1" data-testid="btn-edit-admin-note">
            <Pencil className="w-3 h-3" /> {note ? "Editar" : "Adicionar"}
          </button>
        )}
      </div>
      {editing ? (
        <div className="mt-2 space-y-2">
          <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={3} className="bg-white" autoFocus data-testid="input-admin-note" />
          <div className="flex justify-end gap-2">
            <Button size="sm" variant="ghost" onClick={() => { setEditing(false); setText(note || ""); }}>Cancelar</Button>
            <Button size="sm" onClick={save} disabled={saving} className="bg-amber-600 hover:bg-amber-700 text-white" data-testid="btn-save-admin-note">Salvar</Button>
          </div>
        </div>
      ) : (
        note ? <p className="mt-1 text-[12.5px] text-slate-800 whitespace-pre-wrap break-words" data-testid="admin-note-text">{note}</p>
          : <p className="mt-1 text-[11.5px] text-amber-700/70">Nada anotado. Não aparece para a escola nem no PDF.</p>
      )}
    </section>
  );
}
